import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const VerifiedArtistContext = createContext({
  verifiedUsernames: {},
  isVerified: () => false,
  getArtistName: () => null,
  refreshVerified: () => {},
});

export const VerifiedArtistProvider = ({ children }) => {
  const [verifiedUsernames, setVerifiedUsernames] = useState({});

  const fetchVerified = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/artist-verification/verified-usernames`);
      if (res.ok) {
        const data = await res.json();
        setVerifiedUsernames(data.verified_usernames || {});
      }
    } catch (err) {
      console.error('Failed to fetch verified artists:', err);
    }
  }, []);

  useEffect(() => {
    fetchVerified();
  }, [fetchVerified]);

  // Poll every 30 seconds to pick up newly verified artists
  useEffect(() => {
    const interval = setInterval(fetchVerified, 30000);
    return () => clearInterval(interval);
  }, [fetchVerified]);

  const isVerified = (username) => {
    if (!username) return false;
    return !!verifiedUsernames[username.toLowerCase()];
  };

  const getArtistName = (username) => {
    if (!username) return null;
    return verifiedUsernames[username.toLowerCase()] || null;
  };

  return (
    <VerifiedArtistContext.Provider value={{ verifiedUsernames, isVerified, getArtistName, refreshVerified: fetchVerified }}>
      {children}
    </VerifiedArtistContext.Provider>
  );
};

export const useVerifiedArtists = () => useContext(VerifiedArtistContext);
